import {
  SurveySettings,
  ThirdPartyType,
} from '../../types';
import { apiError } from '../../utils/errors';
import { fetchWithRetry } from '../../utils/fetch-with-retry';
import { getApiBaseUrl } from '../../utils/api-base-url';

export interface AdditionalThirdPartiesData {
  settings: SurveySettings;
  type: ThirdPartyType;
}

export const getAdditionalThirdPartiesData = async (
  urlSlug: string,
  publicId: string,
  token?: string,
  type?: string,
): Promise<AdditionalThirdPartiesData> => {
  const baseUrl = `${getApiBaseUrl()}/submissions/${urlSlug}/${publicId}/additional-third-parties`;
  const params = new URLSearchParams();
  if (token) params.append('token', token);
  if (type) params.append('type', type);
  const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
  const response = await fetchWithRetry(url, { credentials: 'include' });
  const responseJson = await response.json();

  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to fetch additional third parties data', responseJson?.code);
  }

  return responseJson.data;
};
